import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { IServiceCode } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/admin/serviceCodes';

interface IGetRequest {
  isSendOut: boolean;
}

interface IGetResult {
  serviceCodes: IServiceCode[];
}

interface ISubmitRequest {
  id: number;
  code: string;
}

export default {
  get(req: IGetRequest, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, { params: req })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  submit(req: ISubmitRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($url, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  delete(id: number, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .delete($url, {
        data: {
          id,
        },
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
